angular.module('impactx.catalog').controller('CatalogRemoveOrderStopCtrl', [
    '$scope',
    'dataGen',
    'ToastService',
    '$mdDialog',
    'TranslationService',
    CatalogRemoveOrderStopCtrl
]);

function CatalogRemoveOrderStopCtrl($scope, dataGen, ToastService, $mdDialog, TranslationService) {
    var ctrl = this;
    ctrl.abortTrns = TranslationService.get('abort');
    ctrl.warningTrns = TranslationService.get('warning');

    ctrl.cancel = function () {
        $mdDialog.cancel();
    };

    ctrl.removeOrderStop = function () {
        dataGen.postAsForm($scope, {catId: ctrl.catId, removeManualOrderStop: true},
            "/catalog/orderstop/remove").then(function() {
            $mdDialog.hide();
        });
    };
}